export enum ShareDocumentSubject {
  SHARE_DOCUMENT = 'SHARE_DOCUMENT',
  REQUEST_APPROVAL = 'REQUEST_APPROVAL',
}
